export const LANGUAGE_COUNTRY_CODE: RegExp = /^[a-z]{2}-[A-Z]{2}$/i;
